module.exports = "../../../../platform/assets/pageMainIcon/cd-common-other1.svg";